"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const S = (0, tslib_1.__importStar)(require("./styles"));
const Label = ({ label, inputName, fontFamily = 'PFDINText', className, labelStyle = 'default', }) => {
    return ((0, jsx_runtime_1.jsx)(S.StyledLabel, Object.assign({ "data-testid": "label", className: className, fontFamily: fontFamily, htmlFor: inputName, labelStyle: labelStyle }, { children: label }), void 0));
};
exports.default = Label;
